export default "__VITE_ASSET__Db6wA0kE__"